import React from 'react';

const GSLogo = ({ size = 32, color = '#fff' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Rounded square background - Apple style */}
            <rect
                x="5"
                y="5"
                width="90"
                height="90"
                rx="20"
                fill={color}
                fillOpacity="0.1"
                stroke={color}
                strokeWidth="2"
            />

            {/* G letter */}
            <path
                d="M 30 35 
                   C 30 28, 35 23, 42 23
                   C 49 23, 54 28, 54 35
                   L 54 45
                   L 42 45
                   L 42 40
                   L 49 40
                   L 49 35
                   C 49 31, 46 28, 42 28
                   C 38 28, 35 31, 35 35
                   L 35 65
                   C 35 69, 38 72, 42 72
                   C 46 72, 49 69, 49 65
                   L 49 60
                   L 54 60
                   L 54 65
                   C 54 72, 49 77, 42 77
                   C 35 77, 30 72, 30 65
                   Z"
                fill={color}
            />

            {/* S letter */}
            <path
                d="M 58 35
                   C 58 28, 63 23, 70 23
                   C 77 23, 82 28, 82 35
                   L 77 35
                   C 77 31, 74 28, 70 28
                   C 66 28, 63 31, 63 35
                   C 63 39, 66 42, 70 42
                   C 77 42, 82 47, 82 55
                   C 82 62, 77 67, 70 67
                   C 63 67, 58 62, 58 55
                   L 63 55
                   C 63 59, 66 62, 70 62
                   C 74 62, 77 59, 77 55
                   C 77 51, 74 48, 70 48
                   C 63 48, 58 43, 58 35
                   Z"
                fill={color}
            />

            {/* Cinema text below */}
            <text
                x="50"
                y="92"
                textAnchor="middle"
                fill={color}
                fontSize="12"
                fontWeight="600"
                fontFamily="-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif"
            >
                CINEMA
            </text>
        </svg>
    );
};

export default GSLogo;
